import styled from "styled-components";
import { COLORS } from "../../../../../../../assets/constants/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
`;

export const Item = styled.div`
  background-color: ${COLORS.white};
  border: 2px solid ${COLORS.lightGrey};
  border-radius: 8px;
  padding: 16px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  ${(props) =>
    props.isHighlighted &&
    `
    font-weight: 600;
  `}
`;

export const CircleIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.isHighlighted ? COLORS.violet : COLORS.lightestGrey};
  color: ${(props) => (props.isHighlighted ? COLORS.white : COLORS.grey)};
  margin-right: 8px;
  font-size: 12px;
  font-weight: 600;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: ${(props) => (props.isHighlighted ? "600" : "normal")};
  color: ${COLORS.black};
`;

export const Description = styled.div`
  font-size: 14px;
  line-height: 1.5;
  margin-left: 32px;
  color: ${COLORS.darkGrey};
  white-space: pre-wrap;
  word-break: break-word;
`;

export const SecondaryText = styled.div`
  font-size: 13px;
  color: ${COLORS.grey};
  margin: 8px 0;
  margin-left: 32px;
  font-style: italic;
`;
